import { render, staticRenderFns } from "./Produtos.vue?vue&type=template&id=3b747b3e&"
import script from "./Produtos.vue?vue&type=script&lang=js&"
export * from "./Produtos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports